import { createRoute } from "./createRoute.js";
import { captureReturnTo } from "./returnTo.js";

/** The sign-in page, carrying the given location to return to afterwards. */
export const signInPageUrl = (location: {
  origin: string;
  pathname: string;
  search: string;
}): string =>
  `${location.origin}${createRoute.signIn(captureReturnTo(location))}`;

/**
 * Sends the browser to sign in from wherever it is. A full page load rather
 * than a router navigation: the page is torn down, so a caller may leave work
 * pending behind it.
 */
export const redirectToSignIn = (): void => {
  window.location.href = signInPageUrl(window.location);
};
